<template>
  <div class="attribute flex flex-col">
    <el-row>
      <el-input
        v-model="query.keyword"
        size="small"
        class="w-200px"
        placeholder="编码或名称"
        @keyup.enter.native="searchList"
        clearable
      />
      <el-button class="ml-10px" size="small" type="primary" @click="searchList">{{
        $t('search')
      }}</el-button>
      <el-button
        class="r"
        :disabled="multiple"
        size="small"
        type="primary"
        @click="add"
        v-if="!single"
        >{{ $t('addTo') }}</el-button
      >
    </el-row>
    <el-row class="flex-1 mt-20px h-320px">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%"
        border
        @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          v-if="!single"
        ></el-table-column>
        <el-table-column prop="code" :label="$t('encode')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" :label="$t('Name')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" :label="$t('operate')" width="150" v-if="single">
          <template v-slot="scope">
            <el-button size="mini" @click="singleAdd(scope.row)">{{ $t('confirm') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        class="mt-20px"
        background
        @size-change="searchList()"
        @current-change="getList()"
        :current-page.sync="query.pageNum"
        :page-sizes="$pageSizeAll"
        :page-size.sync="query.pageSize"
        layout="->, total, sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'

export default {
  name: 'assetQuery',
  props: ['single', 'standardId'],
  data() {
    return {
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 15,
        keyword: '',
      },
      dataList: [],
      selection: [],
      multiple: true,
      loading: false,
    }
  },
  created() {
    this.searchList()
  },
  methods: {
    searchList() {
      this.query.pageNum = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      const parameter = {
        standard_id: this.standardId,
        keyword: this.query.keyword,
        pageno: this.query.pageNum,
        pagesize: this.query.pageSize,
      }
      const res = await stdClassListService.getStandardAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.dataList = res.data
        this.total = res.page.recordCount
      }
      this.loading = false
    },
    // 单个
    singleAdd(row) {
      this.$emit('selectAttributeId', row)
    },
    // 多个
    add() {
      this.$emit('selectAttributeId', this.selection)
    },
    selectionChange(val) {
      this.selection = val
      this.multiple = !val.length
    },
  },
}
</script>
<style lang="scss" scoped>

.attribute {
  height: 500px;
  /deep/.el-table__body-wrapper {
    height: 90% !important;
  }
}

</style>
